/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  "'Goals.CreateGoal.footer.create-label": 'Vytvořit',
  'Goals.CreateGoal.create.error': 'Vytvoření cíle se nezdařilo',
  'Goals.CreateGoal.create.network.error': 'Připojení se nezdařilo',
  'Goals.CreateGoal.create.permission.error': 'K vytvoření cíle nemáte požadované oprávnění.',
  'Goals.CreateGoal.error.description': 'Něco se pokazilo, zkontrolujte připojení k internetu a zkuste to znovu.',
  'Goals.CreateGoal.error.header': 'Vytvoření cíle se nezdařilo',
  'Goals.CreateGoal.footer.cancel-label': 'Zrušit',
  'Goals.CreateGoal.form.icon.back-button-label': 'Zpět',
  'Goals.CreateGoal.form.name.error': 'Je nutné uvést název cíle',
  'Goals.CreateGoal.form.name.label': 'Název',
  'Goals.CreateGoal.form.owner.error': 'Vlastník nesmí být prázdný.',
  'Goals.CreateGoal.header': 'Vytvořit cíl',
  'Goals.CreateGoal.parent-goal-label': 'Nadřazený cíl',
  'Goals.CreateGoal.parent-goal.error': 'Nadřazený cíl nesmí být prázdný.',
  'Goals.CreateGoal.required-fields-are-marked': 'Povinná pole jsou označena hvězdičkou <asterisk></asterisk>',
  'Goals.CreateGoal.site-label': 'Web',
  'Goals.CreateGoal.type-label': 'Typ',
  'Goals.CreateGoal.type-label-placeholder': 'Jak tuto položku pojmenujeme?',
  'Goals.GoalCreationModal.label.date-selection-placeholder': 'Vyberte datum.',
  'Goals.GoalCreationModal.label.date-selection-title': 'Cílové datum',
  'Goals.GoalCreationModal.label.owner-picker-placeholder': 'Zadejte osobu.',
  'Goals.GoalCreationModal.label.owner-selection-title': 'Vlastník',
  'townsquare.api.goal-type-description.goal': 'Univerzální cíle',
  'townsquare.api.goal-type-description.key-result': 'Kvantitativní způsob měření dílčího cíle (rámec OKR).',
  'townsquare.api.goal-type-description.objective': 'Výsledek, kterého chcete dosáhnout (rámec OKR).',
};
